(() => {
  const root = document.querySelector("[data-media-archive]");
  if (!root) return;

  const filters = root.querySelectorAll("[data-filter]");
  const items = Array.from(root.querySelectorAll(".media-archive__item"));
  const emptyMessage = root.querySelector("[data-empty-message]");
  const list = root.querySelector(".media-archive__list");

  const sortByDateDesc = () => {
    if (!list || items.length === 0) return;

    items
      .slice()
      .sort((a, b) => {
        const dateA = a.dataset.date || "";
        const dateB = b.dataset.date || "";
        if (dateA === dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;
        return dateA < dateB ? 1 : -1;
      })
      .forEach((item) => list.appendChild(item));
  };

  const applyFilter = (filterValue) => {
    let visibleCount = 0;

    items.forEach((item) => {
      const type = (item.dataset.type || "").toLowerCase();
      const visible = filterValue === "all" || type === filterValue;
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  };

  filters.forEach((button) => {
    button.addEventListener("click", () => {
      const filterValue = button.dataset.filter;

      filters.forEach((filterButton) => {
        const isActive = filterButton === button;
        filterButton.classList.toggle("is-active", isActive);
        filterButton.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      applyFilter(filterValue);
    });
  });

  sortByDateDesc();
  applyFilter("all");
})();
